import axios from 'axios'
import { AbstractService } from "./abstract.service";

export class StoreMerchantService extends AbstractService {
  static get entity() {
    return "proxy-gateway/gw-core";
  }

  static get entity_1() {
    //return "nsh/item/api/v1/item"
    return "nsh/item/items"
  }

  static get entityStore() {
    return "nsh/store/api/store"
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getListMerchant(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity_1}/search-item-merchant`,
        params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListProduct(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/item-compound/search-v2`,
        params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getInforMerchant(params) {
    try {
      const response = await this.callApi().get(
        `${this.entityStore}/getByCoMerchantIdAndCoLocationId?coMerchantId=${params.merchantId}&coLocationId=${params.locationId}`
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getProductDetail(idItem) {
    try {
      const response = await this.callApi().get(
        `${this.entity}/item-compound/${idItem}`
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message);
    }
  }

  static async getMerchantAliasName(params) {
    try {
      const response = await axios.get(
        `${this.URL_GATEWAY}/${this.entityStore}/getByMerchantAliasName/${params}`,
        {
          headers: {
            "np-merchant-id": params.merchantId,
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }
}
